import Navbar from "../components/Navbar";
import { FaAngleDoubleDown } from "react-icons/fa";
import SubscribeNowBanner from "../components/SubscribeNowBanner";
import FAQAccordion from "../components/FAQAccordion";
import HompageFaqs from "../data/HompageFaqs";
import CardCarousel from "../components/CardCarousel";
import TeamList from "../data/TeamList";
import { Helmet } from 'react-helmet-async';

const FacultyPage = () => {
  const scrollToContent = () => {
    const section = document.getElementById("explore");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <Helmet>
        <title>About - Art India Education</title>
      </Helmet>
      <main>
        <Navbar />
        {/* Top Half-Screen Banner Section */}
        <section className="relative h-screen w-full overflow-hidden font-['EB_Garamond','Nunito','sans-serif']">
          <div className="relative w-full h-full overflow-hidden">
            {/* 🔳 Overlay */}
            <div className="absolute inset-0 bg-black/50 z-10"></div>

            {/* 🖼️ Image */}
            <img
              src="about-us-banner-background.jpg"
              alt={`banner`}
              className="absolute top-[-25%] h-[150%] w-full object-cover z-0"
            />

            {/* 📄 Text Wrapper */}
            <div className="absolute inset-0 z-20 flex flex-col justify-center items-center text-white text-center px-4">
              <h1 className="text-8xl font-extrabold mb-6">Move Closer to Art</h1>
              <p className="text-2xl font-medium max-w-2xl font-['EB_Garamond','Nunito','sans-serif']">
                The platform brings you exciting ways dynamic ways of exploring Modern and
                Contemporary Indian Art as we examine various periods in art history.
              </p>
            </div>
          </div>
          {/* ⬇️ Double Down Arrow */}
         <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce">
            <FaAngleDoubleDown size={32} />
          </div>
          <button
            onClick={scrollToContent}
            className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 text-white animate-bounce"
            aria-label="Scroll to content"
          >
            <FaAngleDoubleDown size={32} />
          </button>
        </section>
        <div id="explore" className="relative p-10 bg-[rgb(234,126,93)]">
          <section className="text-center py-16 px-6 ">
            <h2 className="text-4xl font-bold text-white text-bold  font-['EB_Garamond','Nunito','sans-serif']">
              MISSION & VISION
            </h2>
            <p className="text-xl text-white font-bold max-w-3xl mx-auto mt-4 font-['EB_Garamond','Nunito','sans-serif']">
              Our mission is to deepen the discussion around artists and art practises,
              by guiding you towards a layered understanding of diverse topics.
              This platform facilitates an environment that is conducive to creating
              informed interpretations of Indian art.
            </p>

            <p className="text-xl text-white font-bold max-w-3xl mx-auto mt-4 font-['EB_Garamond','Nunito','sans-serif']">
              Our initiative seeks to develop exciting ways to explore the rich and diverse history of Indian Art.
              We hope to enable a critical appreciation of Indian art and its contexts.
            </p>
          </section>
        </div>

        <div id="explore" className="relative p-10 bg-white">
          <section className="text-center py-16 px-6 ">
            <h2 className="text-4xl font-bold text-black text-bold  font-['EB_Garamond','Nunito','sans-serif']">
              WHY SUBSCRIBE?
            </h2>
            <p className="text-xl text-black font-bold max-w-3xl mx-auto mt-4 font-['EB_Garamond','Nunito','sans-serif']">
              Gain access to the history behind India’s key works through a digital series curated
              by Art India Magazine, who have been pioneers in fostering critical dialogue around
              Indian art over the last 25 years.
            </p>
          </section>
          {/* Content */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 pl-20 pr-20">
            {[
              {
                src: "/art-education-india-1.png",
                text: "Delve into expert perspectives and insider knowledge from the field.",
              },
              {
                src: "/art-education-india-2.png",
                text: "Explore the finest artworks from coveted collections across the country, including the JSW Group and Jindal Family Collection.",
              },
              {
                src: "/art-education-india-3.png",
                text: "Build your prowess through insightful perspectives into Modern and Contemporary Indian Art.",
              },
            ].map((card, index) => (
              <div
                key={index}
                className={`flex flex-col items-center relative ${index !== 2 ? "border-r border-[rgb(234,126,93)]" : ""
                  }`}
              >
                <img
                  src={card.src}
                  alt="artwork"
                  className="w-25 max-w-xs h-40 object-cover rounded-lg "
                />
                <p className="text-sm font-bold text-gray-700 text-center pl-10 pr-10 pt-10 font-['EB_Garamond','Nunito','sans-serif']">{card.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Centered Logo Below Cards */}
        <div className="flex justify-center py-10">
          <img src="/Black-logo-without-tagline.svg" alt="Logo" className="h-16 w-auto transform scale-150" />
        </div>

        <section className="max-w-7xl mx-auto px-6 py-16 text-center font-['EB_Garamond','Nunito','sans-serif']">
          {/* Heading */}
          <h2 className="text-4xl mb-12">
            <span className="relative inline-block text-black font-bold">
              ABOUT
              <span className="block h-[2px] w-full bg-[rgb(234,126,93)] mt-2"></span>
            </span>{" "}
            US
          </h2>

          {/* Two-column Paragraph Block */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 text-left text-lg text-gray-700 font-['EB_Garamond','Nunito','sans-serif']">
            <p className="text-justify">
              The Art India Education initiative is an attempt at fusing together the lecture format approach
              with films and dynamic discussions to generate excitement around learning and enjoying visual art.
              Art India Magazine introduces a robust online learning platform delivering quality art history content.
              This initiative is an attempt at fusing together an online lecture format approach with films and
              discussions to create a dynamic knowledge mosaic.  The expert insights from renowned art professionals
              give you a comprehensive perspective of modern art in India.
              These educational videos make your quest for understanding Indian art history a delightful process.
            </p>
            <p className="text-justify">
              The digital platform is intended to build foundational knowledge for beginners and enthusiasts alike.
              A simple and affordable one-time payment grants you all-year access to the platform.
              Its primary purpose is to serve as Art India’s educational arm which will encourage
              inquiry – based and visually engaging learning for future stakeholders of art.
              The masterclasses will continue the umbrella brand’s vision to bring art to a
              wider audience – this time, within a learning setting and with a quest to clearly
              and simply present history, criticism, watershed moments, and much more.
              Discover a new way to explore Indian art history today!
            </p>

            {/*left Column*/}
            <div className="flex justify-center items-center pt-10">
              <img
                src="/About-artindia.jpg"
                alt="About Art India"
                className="h-auto object-contain transform"
                style={{ maxWidth: '300px' }}
              />
            </div>
            {/* Right Column */}
            <div className="flex flex-col justify-center space-y-6">
              <h2 className="text-4xl mb-6">
                ABOUT{" "}
                <span className="relative inline-block text-black font-bold">
                  ART INDIA
                  <span className="block h-[2px] w-full bg-[rgb(234,126,93)] mt-2"></span>
                </span>
              </h2>
              <p className="text-justify">
                Being India’s premier art magazine, Art India has over the last twenty-five years been
                responsible for the promotion of critical discourse around diverse art forms, activities and disciplines.
              </p>
              <p className="text-justify">
                As an important forum for discussing, interrogating and appreciating art practices in South Asia,
                it has given a platform to artists and critics alike to engage in mutually beneficial dialogues.
                This has led to the fostering of a vibrant atmosphere of sustained debate around crucial issues
                linked to the theory and practice of painting, sculpture, installation art, new media art, photography,
                performance art and architecture.
              </p>
            </div>
            <div>
              <h2 className="text-4xl mb-12 pt-10">
                ABOUT{" "}
                <span className="relative inline-block text-black font-bold">
                  JSW GROUP
                  <span className="block h-[2px] w-full bg-[rgb(234,126,93)] mt-2"></span>
                </span>
              </h2>
              <p className="text-justify">
              JSW Group is a multinational conglomerate and one of India’s most diverse and dynamic business entities. With its headquarters in Mumbai, the Group has a significant presence across steel, energy, cement, infrastructure, paints, electric mobility, defence, copper, venture capital, and sports. JSW Steel, its flagship company, is ranked among the world’s leading steel manufacturers. JSW Energy is advancing India’s clean energy ambitions, while JSW Cement and JSW Paints are redefining sustainability in construction and coatings. Beyond business, JSW invests in sports, technology, and community-driven initiatives, fostering inclusive growth. With operations spanning India, the US, Europe, and Africa, JSW is shaping a sustainable and progressive future.
              </p>
            </div>
            <div className="flex justify-center items-center pt-10">
              <img
                src="/JSW_Group_logo-min-2048x969.png"
                alt="JSW GROUP"
                className="h-auto object-contain transform"
                style={{ maxWidth: '300px' }}
              />
            </div>
            {/*left Column*/}
            <div className="flex justify-center items-center pt-10">
              <img
                src="/Sangita-Jindal-min.jpg"
                alt="About Founder"
                className="h-auto object-contain transform"
                style={{ maxWidth: '500px' }}
              />
            </div>
            {/* Right Column */}
            <div className="flex flex-col justify-center space-y-6">
              <h2 className="text-4xl mb-6">
                FROM THE{" "}
                <span className="relative inline-block text-black font-bold">
                  FOUNDER
                  <span className="block h-[2px] w-full bg-[rgb(234,126,93)] mt-2"></span>
                </span>
              </h2>
              <p className="text-justify">
                “Over the last 25 years, Art India has played an important role in the world of South Asian art.
                It has created a forum for inspired interaction between artists, critics, historians, architects,
                writers and collectors and has had a definitive impact on the community.
              </p>
              <p className="text-justify">
                With Art India Education, we hope to invite students and teachers to participate in the process of
                continuous learning, an ideal I firmly believe in. Being a student instils one’s life with meaning
                and value – a good reason to continue to educate oneself throughout life. Our new initiative hopes
                to make learning about modern and contemporary art a more buoyant experience – one that is enjoyable
                and illuminating in equal measure.”
              </p>
              <p className="whitespace-pre-line">
                {`Sangita Jindal
            Chairperson of JSW Foundation
            and Founder of Art India Magazine & Art India Education`}
              </p>
            </div>

          </div>
        </section>
        <div className="pl-10 pr-10">
          <CardCarousel list={TeamList} />
        </div>

        <section className="pl-20 pt-16 pr-20">
          <h2 className="text-4xl font-bold text-black font-['EB_Garamond','Nunito','sans-serif']">
            FREQUENTLY ASKED <span className="font-bold relative text-[rgb(234,126,93)] after:content-[''] after:block after:h-[3px] after:w-full after:bg-[rgb(234,126,93)] after:mt-1">QUESTIONS</span>
          </h2>
        </section>
        <div className="pb-12">
          <FAQAccordion faqs={HompageFaqs} />
        </div>
        <SubscribeNowBanner />
      </main>
    </>
  );
};
export default FacultyPage;